export const GRETA_AI_CHAT_REPLY_TIMEOUT_MS = 120000

// Bounds each request of the post-reply check that holds Send (normally one round trip).
export const GRETA_AI_CHAT_DEFERRED_CHECK_TIMEOUT_MS = 10000
